
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s-public/[speciali]/all",
      function () {
        return require("private-next-pages/s-public/[speciali]/all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s-public/[speciali]/all"])
      });
    }
  